import { VoteCount } from "./VoteCount";

export default VoteCount;